import React from 'react';
import SidebarComponent from './SidebarComponent';
import PageHeader from './PageHeader';

const RevampingOfWaterTreatmentPlants: React.FC = () => {
  return (
    <>
      <PageHeader title="Revamping of Water Treatment Plants" />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/revamping.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/revamping.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Revamping of Water Treatment Plants</h1>
              <p>WTIL specializes in the assessment, retrofitting, and modernization of existing water treatment facilities. Our revamping services aim to improve system efficiency, reduce operational costs, and bring old plants up to modern performance and regulatory standards.</p>

              <h3 className="mb-4">Revamping Focus Areas:</h3>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Capacity enhancement</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Automation upgrades</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Equipment replacement</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Energy & chemical optimization</p>
            </div>

            <div className="col-lg-4">
              <SidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default RevampingOfWaterTreatmentPlants;
